import { Injectable } from '@angular/core';
import { Filters } from 'app/model/filters';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {
  private currentSearch: string
  private currentFilters: Filters

  constructor() {
    this.clearFiltersAndText()
  }

  public filterByText(words: string, data: any[]): any[] {
    this.currentSearch = words

    return this.filterData(data)
  }

  public filterBy(filters: Filters, data: any[]): any[] {
    this.currentFilters = filters

    return this.filterData(data)
  }

  public getFilters(): Filters {
    return this.currentFilters
  }

  public clearFilters(): void {
    this.currentFilters = {}
  }

  public clearCurrentSearch(): void {
    this.currentSearch = ''
  }

  public clearFiltersAndText(): void {
    this.clearCurrentSearch()

    this.clearFilters()
  }

  private filterData(data: any[]): any[] {
    const currentSearch = this.currentSearch
    const currentFilters = this.currentFilters

    return data.filter(item => {
      const globalText = this.normalizeText(JSON.stringify(item))

      const matchesText = currentSearch === '' || globalText.includes(this.normalizeText(currentSearch.toLowerCase()))

      const matchesAllFilters = Object.entries(currentFilters).every(([field, value]) => {
        if (!value) return true

        const fieldValue = this.getNestedValue(item, field)

        return fieldValue?.toString().toLowerCase() === value.toString().toLowerCase()
      })

      return matchesText && matchesAllFilters
    })
  }

  private normalizeText(text: string): string {
    return text?.toLocaleLowerCase()
      .normalize('NFD') // Separa letras y tildes
      .replace(/[\u0300-\u036f]/g, '')  // Elimina tildes
  }

  public getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, key) => {
      if (Array.isArray(acc)) { // Si es array mapea la propiedad que se indique y convierte [[]] en []
        return acc
          .map((item) => item?.[key])
          .reduce((a, b) => a.concat(b), [])
      }

      return acc?.[key]
    }, obj)
  }
}
